(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8625],{

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 23279:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    now = __webpack_require__(7771),
    toNumber = __webpack_require__(14841);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 7771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),

/***/ 32411:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/article-template-page",
      function () {
        return __webpack_require__(65415);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 37531:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgV = function SvgV(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 20,
        viewBox: "0 0 26 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        d: "M9 14 3 8l-3 3 6 6 3 3 3-3L26 3l-3-3z"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgV);


/***/ }),

/***/ 39055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path, _path2;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgEarth = function SvgEarth(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20"
    }, props), _path || (_path = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M10 19a9 9 0 1 0 0-18 9 9 0 0 0 0 18"
    })), _path2 || (_path2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
        stroke: "#323338",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7.831 18.737C6.613 16.95 5.8 13.707 5.8 10s.813-6.951 2.031-8.737M1 10h18M2.386 14.8h15.229M2.386 5.2h15.229M12.169 1.263C13.386 3.05 14.2 6.293 14.2 10s-.813 6.951-2.031 8.737"
    })));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgEarth);


/***/ }),

/***/ 48124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_addons_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/ouibounce/build/ouibounce.js
var ouibounce = __webpack_require__(5499);
var ouibounce_default = /*#__PURE__*/__webpack_require__.n(ouibounce);
// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-constants.js
var EXIT_POPUP_TEXT = {
    en: {
        TITLE: '"I want to hug the people that created this."',
        SUBTITLE: "- Emma J Coulson, with monday.com since 2014",
        SIGNUP_HEADER_TEXT: "Join 15,000+ teams who are passionate about monday.com",
        SIGNUP_INPUT_PLACEHOLDER: "Enter your work email",
        SIGNUP_BUTTON_TEXT: "Get free access now",
        SIGNUP_FOOTER_TEXT: "No thanks"
    },
    fr: {
        TITLE: "Vous n'avez pas le temps... Nous comprenons :)",
        SUBTITLE: "Envoyez-vous une invitation maintenant, et d\xe9butez quand vous avez 3 minutes",
        SIGNUP_INPUT_PLACEHOLDER: "Entrez votre adresse e-mail",
        SIGNUP_BUTTON_TEXT: "m'inviter"
    },
    es: {
        TITLE: "Est\xe1s ocupado... Te entendemos :)",
        SUBTITLE: "Env\xedate una invitaci\xf3n ahora y prueba monday.com cuando tengas 3 minutos",
        SIGNUP_INPUT_PLACEHOLDER: "Ingresa tu correo laboral",
        SIGNUP_BUTTON_TEXT: "Enviar"
    },
    de: {
        TITLE: "Du bist besch\xe4ftigt… wir verstehen das :)",
        SUBTITLE: "Sende dir jetzt selbst eine Einladung und probiere uns aus, wenn 3 Minuten Zeit hast",
        SIGNUP_INPUT_PLACEHOLDER: "Ihre Firmen-E-Mail-Adresse",
        SIGNUP_BUTTON_TEXT: "Mich selbst einladen"
    },
    it: {
        TITLE: "Sei impegnato... ti capiamo :)",
        SUBTITLE: "Mandati un auto-invito, e mettici alla prova quando hai 3 minuti liberi",
        SIGNUP_INPUT_PLACEHOLDER: "Inserisci la tua email aziendale",
        SIGNUP_BUTTON_TEXT: "Invita Me Stesso"
    }
};
var EXIT_POPUP_ORIGIN = "hp_exit_intent_modal";

// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./services/ab-tests/acquisition-ab-test-service.js
var acquisition_ab_test_service = __webpack_require__(77784);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.scss.js



var StyledModalBackgroundComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ebjt820"
})("position:fixed;width:100%;height:100%;background-color:", colors/* default.black */.Z.black, ";opacity:0.9;top:0;left:0;z-index:", z_index/* MODAL_BACKGROUND */.AE, ";");

;// CONCATENATED MODULE: ./components/enhancements/modal-background/modal-background-component.js


var ModalBackgroundComponent = function(props) {
    var onClick = props.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledModalBackgroundComponent, {
        className: "modal-background",
        onClick: onClick
    });
};
/* harmony default export */ var modal_background_component = (ModalBackgroundComponent);

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.scss.js


var componentStyle = new String(".header-text.jsx-fb833f46e36abbce{margin-bottom:16px}");
componentStyle.__hash = "fb833f46e36abbce";
var signupBoxStyle = new String(".exit-popup-signup{.footer-text{cursor:pointer;color:darken(#fff,10%)}.exit-popup-signup-box{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;.signup-form{margin-bottom:16px;margin-top:0}.signup-input{height:56px;width:224px;padding:0 24px;-webkit-border-radius:50px 0 0 50px;-moz-border-radius:50px 0 0 50px;border-radius:50px 0 0 50px;border:1px solid transparent;margin-right:0;color:".concat(colors/* default.black */.Z.black, ";vertical-align:bottom;font-size:.875rem;&:focus{outline:0}}.signup-button{height:56px;min-width:200px;background:#f4ce2f;-webkit-border-radius:0 50px 50px 0;-moz-border-radius:0 50px 50px 0;border-radius:0 50px 50px 0;border:1px solid transparent;padding:0 10px;color:#333;font-size:.875rem;vertical-align:bottom;&:hover{background:darken(#f4ce2f,5%);border:#f4ce2f}}}}@media(max-width:").concat(vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.exit-popup-signup{.exit-popup-signup-box .signup-form-core-component-wrapper form{-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;.signup-button-wrapper{width:auto;padding:8px 0 16px 0}}}}"));
signupBoxStyle.__hash = "98a26903dd2c2d5b";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-signup/exit-popup-signup-component.js











var ExitPopupSignup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupSignup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupSignup);
    function ExitPopupSignup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopupSignup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            value: ""
        };
        _this.onInputChange = _this.onInputChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopupSignup, [
        {
            key: "onInputChange",
            value: function onInputChange(e) {
                var value = e.target.value.value;
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerText = _props.headerText, inputPlaceholder = _props.inputPlaceholder, buttonText = _props.buttonText, footerText = _props.footerText, origin = _props.origin, onClickFooterText = _props.onClickFooterText;
                var value = this.state.value;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup",
                    children: [
                        headerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "header-text",
                            children: headerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "exit-popup-signup-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                placeholder: inputPlaceholder,
                                ctaText: buttonText,
                                useCtaText: !!buttonText,
                                origin: origin,
                                forceDefaultForm: true
                            })
                        }),
                        footerText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: onClickFooterText,
                            className: "jsx-".concat(signupBoxStyle.__hash, " jsx-").concat(componentStyle.__hash) + " " + "footer-text",
                            children: footerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: componentStyle.__hash,
                            children: componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: signupBoxStyle.__hash,
                            children: signupBoxStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupSignup;
}(react.PureComponent);

ExitPopupSignup.defaultProps = {
    headerText: "Join <monday-paying-companies />+ teams who are passionate about monday.com",
    buttonText: "Get free access now",
    inputPlaceholder: "Enter your work email",
    footerText: "No thanks"
};

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.scss.js


var exit_popup_content_component_scss_componentStyle = new String(".exit-popup-content-component.jsx-c4034e412f97cb55{position:fixed;z-index:".concat(z_index/* MODAL_BACKGROUND */.AE + 1, ";left:50%;top:50%;-webkit-transform:translate(-50%,-50%);-moz-transform:translate(-50%,-50%);-ms-transform:translate(-50%,-50%);-o-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:720px;padding:56px 40px 40px 40px;-webkit-border-radius:4px;-moz-border-radius:4px;border-radius:4px;background:#333;color:#fff;text-align:center;.content-title.jsx-c4034e412f97cb55{font-size:3vw;font-weight:500;margin:0}.content-subtitle.jsx-c4034e412f97cb55{font-size:1.2vw;margin-bottom:56px}}"));
exit_popup_content_component_scss_componentStyle.__hash = "c4034e412f97cb55";
var closeIconStyle = new String(".exit-popup-close.jsx-76784fb04befc36c{position:absolute;top:0;right:0;width:60px;height:60px;background:-webkit-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-moz-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:-o-linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);background:linear-gradient(45deg,#787878 0%,#787878 50%,#343434 50%,#222 61%);-webkit-border-radius:0px 0px 0px 5px;-moz-border-radius:0px 0px 0px 5px;border-radius:0px 0px 0px 5px;.x-button.jsx-76784fb04befc36c{position:absolute;-webkit-transform:rotate(45deg);-moz-transform:rotate(45deg);-ms-transform:rotate(45deg);-o-transform:rotate(45deg);transform:rotate(45deg);top:-4px;right:4px;line-height:1;font-size:2.25rem;color:#787878;-webkit-transition:color.1s ease-in-out;-moz-transition:color.1s ease-in-out;-o-transition:color.1s ease-in-out;transition:color.1s ease-in-out;text-decoration:none;cursor:pointer;&.jsx-76784fb04befc36c:hover,&.jsx-76784fb04befc36c:active,&.jsx-76784fb04befc36c:focus{color:#c4c4c4;text-decoration:none}}}");
closeIconStyle.__hash = "76784fb04befc36c";

;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-content/exit-popup-content-component.js









var ExitPopupContent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopupContent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopupContent);
    function ExitPopupContent() {
        (0,_class_call_check/* default */.Z)(this, ExitPopupContent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ExitPopupContent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupHeaderText = _props.signupHeaderText, singupInputPlaceholder = _props.singupInputPlaceholder, signupButtonText = _props.signupButtonText, signupFooterText = _props.signupFooterText, onClose = _props.onClose, origin = _props.origin;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "exit-popup-close",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                rel: "nofollow",
                                onClick: onClose,
                                className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "x-button pointer tc",
                                children: "+"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-title",
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "jsx-".concat(closeIconStyle.__hash, " jsx-").concat(exit_popup_content_component_scss_componentStyle.__hash) + " " + "content-subtitle",
                            children: subtitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupSignup, {
                            headerText: signupHeaderText,
                            inputPlaceholder: singupInputPlaceholder,
                            buttonText: signupButtonText,
                            footerText: signupFooterText,
                            onClickFooterText: onClose,
                            origin: origin
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: exit_popup_content_component_scss_componentStyle.__hash,
                            children: exit_popup_content_component_scss_componentStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: closeIconStyle.__hash,
                            children: closeIconStyle
                        })
                    ]
                });
            }
        }
    ]);
    return ExitPopupContent;
}(react.PureComponent);


// EXTERNAL MODULE: ./constants/localized-number-of-customers.js
var localized_number_of_customers = __webpack_require__(2522);
;// CONCATENATED MODULE: ./components/addons/exit-popup/exit-popup-component.js


















var ExitPopup = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ExitPopup, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ExitPopup);
    function ExitPopup(props) {
        (0,_class_call_check/* default */.Z)(this, ExitPopup);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isOpen: false
        };
        _this._ouibounce = null;
        _this.onExitIntent = _this.onExitIntent.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onClose = _this.onClose.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ExitPopup, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.initOuibounce();
            }
        },
        {
            key: "initOuibounce",
            value: function initOuibounce() {
                var _props = this.props, timer = _props.timer, aggressive = _props.aggressive, sensitivity = _props.sensitivity, delay = _props.delay, cookieExpire = _props.cookieExpire, cookieDomain = _props.cookieDomain, cookieName = _props.cookieName;
                this._ouibounce = ouibounce_default()(false, {
                    timer: timer,
                    aggressive: aggressive,
                    sensitivity: sensitivity,
                    delay: delay,
                    cookieExpire: cookieExpire,
                    cookieDomain: cookieDomain,
                    cookieName: cookieName,
                    callback: this.onExitIntent
                });
            }
        },
        {
            key: "onExitIntent",
            value: function onExitIntent() {
                var abTests = this.props.abTests;
                if (!(0,acquisition_ab_test_service.shouldSeeReviveExitPopupAbTest)(abTests, true)) return;
                this.props.onExitIntentCallback && this.props.onExitIntentCallback();
                this.setState({
                    isOpen: true
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_OPEN);
            }
        },
        {
            key: "onClose",
            value: function onClose() {
                this.props.onCloseExitPopupCallback && this.props.onCloseExitPopupCallback();
                this.setState({
                    isOpen: false
                });
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.EXIT_POPUP_CLOSE);
            }
        },
        {
            key: "render",
            value: function render() {
                var isOpen = this.state.isOpen;
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, signupConfig = _props.signupConfig, translate = _props.translate, translateWithParam = _props.translateWithParam, localeId = _props.localeId;
                var titleToUse = title || translate("exitPopup.title");
                var subtitleToUse = subtitle || translate("exitPopup.subtitle");
                var signupHeaderTextToUse = signupConfig && signupConfig.headerText || translateWithParam("exitPopup.signupTitle", (0,localized_number_of_customers/* getLocalizedNumberOfPayingTeams */.i)(localeId));
                var inputPlaceholderToUse = signupConfig && signupConfig.inputPlaceholder || translate("exitPopup.signupInputPlaceholder");
                var buttonTextToUse = signupConfig && signupConfig.buttonText || translate("exitPopup.signupButtonText");
                var footerTextToUse = signupConfig && signupConfig.footerText || translate("exitPopup.footerText");
                return isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "exit-popup-overlay",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(modal_background_component, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ExitPopupContent, {
                            title: titleToUse,
                            subtitle: subtitleToUse,
                            signupHeaderText: signupHeaderTextToUse,
                            singupInputPlaceholder: inputPlaceholderToUse,
                            signupButtonText: buttonTextToUse,
                            signupFooterText: footerTextToUse,
                            onClose: this.onClose,
                            origin: EXIT_POPUP_ORIGIN
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {});
            }
        }
    ]);
    return ExitPopup;
}(react.PureComponent);
ExitPopup.defaultProps = {
    timer: 100,
    aggressive: false,
    sensitivity: 5,
    delay: 200,
    cookieExpire: 30,
    cookieDomain: ".monday.com",
    cookieName: cookies.VIEWED_OUI_BOUNCE_MODAL_COOKIE
};
/* harmony default export */ var exit_popup_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(ExitPopup)));

// EXTERNAL MODULE: ./client/services/gtm-service/gtm-service.js
var gtm_service = __webpack_require__(60775);
// EXTERNAL MODULE: ./constants/data-layer-event-types.js
var data_layer_event_types = __webpack_require__(34496);
var data_layer_event_types_default = /*#__PURE__*/__webpack_require__.n(data_layer_event_types);
;// CONCATENATED MODULE: ./components/addons/core-addons/core-addons-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var CoreAddonsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CoreAddonsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CoreAddonsComponent);
    function CoreAddonsComponent() {
        (0,_class_call_check/* default */.Z)(this, CoreAddonsComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CoreAddonsComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                //TODO: Remove and change GTM trigger to page load
                (0,gtm_service/* fireGtmEvent */.k2)((data_layer_event_types_default()).SHOW_COOKIEHUB_DIALOG_EVENT_NAME);
            //If we see that CookieHub Geolocation isn't working well we can fire a GTM event only for relevant countries + another for the rest to launch all cookies
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, exitPopup = _props.exitPopup, exitPopupConfig = _props.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                    children: exitPopup && /*#__PURE__*/ (0,jsx_runtime.jsx)(exit_popup_component, _object_spread({}, exitPopupConfig))
                });
            }
        }
    ]);
    return CoreAddonsComponent;
}(react.PureComponent);
/* harmony default export */ var core_addons_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(CoreAddonsComponent)));


/***/ }),

/***/ 77385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SignupWithTextComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.scss.js


var StyledSignupWithTextComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ewvr9040"
})("width:100%;position:relative;.signup-form-title{text-align:center;margin-bottom:24px;h1{font-weight:500;}}&.with-subtitle{.signup-form-title{margin-bottom:8px;}}&.text-under-buttons{.signup-form-subtitle{margin-bottom:0;margin-top:24px;}}.signup-form-subtitle{text-align:center;h2{font-weight:300;}margin-bottom:24px;}.error-tooltip-text{color:red;font-weight:300;}.tooltip{transform:translate(10%,-120%);}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.tooltip{transform:translate(5%,-120%);}}");

;// CONCATENATED MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var SignupWithTextComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SignupWithTextComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SignupWithTextComponent);
    function SignupWithTextComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SignupWithTextComponent);
        return _super.call(this, props);
    }
    (0,_create_class/* default */.Z)(SignupWithTextComponent, [
        {
            key: "renderTexts",
            value: function renderTexts() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "signup-texts",
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-title",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: title
                            })
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "signup-form-subtitle",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: subtitle
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "renderForm",
            value: function renderForm() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread({}, this.props));
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, subtitle = _props.subtitle, textUnderButtons = _props.textUnderButtons;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSignupWithTextComponent, {
                    className: classnames_default()("signup-form-wrapper", {
                        "with-subtitle": subtitle,
                        "text-under-buttons": textUnderButtons
                    }),
                    children: [
                        textUnderButtons ? this.renderForm() : this.renderTexts(),
                        textUnderButtons ? this.renderTexts() : this.renderForm()
                    ]
                });
            }
        }
    ]);
    return SignupWithTextComponent;
}(react.PureComponent);

SignupWithTextComponent.defaultProps = {
    textUnderButtons: false
};


/***/ }),

/***/ 93030:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CompetitorsComparisonTableComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.scss.js


var StyledCompetitorsComparisonTableComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e98igvu0"
})("text-align:center;margin-top:50px;.competitors-comparison-title{font-size:2.2vw;margin-bottom:20px;font-weight:500;}.competitors-comparison-subtitle{font-size:1.4vw;font-weight:300;line-height:1.3;margin-bottom:20px;}.table-wrapper{padding:50px 100px;.table-header{padding-bottom:20px !important;.vs-cell{font-size:1.463rem;font-weight:400;}}.table-row{display:flex;padding:0px 30px;.table-cell{flex:1 1;height:80px;display:flex;align-items:center;justify-content:center;}.first-cell{justify-content:left;}.monday-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}.competitor-logo-wrapper{width:100%;img{width:80%;max-width:200px;}}}}.mobile-table-wrapper{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.competitors-comparison-titles-wrapper{padding:0px 20px;width:80%;margin:0px auto;.competitors-comparison-title{font-size:1.575rem;text-align:left;line-height:1.3;}.competitors-comparison-subtitle{font-size:0.875rem;text-align:left;line-height:1.5;}}.table-wrapper{display:none;}.mobile-table-wrapper{display:block;margin:50px 0px;.table-header{display:flex;padding:10px 0px;.monday-logo-wrapper,.competitor-logo-wrapper{width:100%;img{width:80%;}}}}}");

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.scss.js


var StyledComparisonFeatureComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egkw7zd0"
})(".table-row{&.even{background:#ecf4f8;border-radius:40px;}&.big-texts{.table-cell:not(.first-cell){font-size:1.375rem;}}}.mobile-table-row{display:none;}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.table-row{display:none;}.mobile-table-row{display:block;.feature-title{display:flex;height:40px;align-items:center;justify-content:center;}.feature-cells{display:flex;height:50px;align-items:center;background:#ecf4f8;border-radius:30px;margin:0px 5vw;.table-cell{flex:1 0;}}}}");

// EXTERNAL MODULE: ./static/svg/competitors-template/v.svg
var v = __webpack_require__(37531);
;// CONCATENATED MODULE: ./static/svg/competitors-template/x.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgX = function SvgX(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 25,
        height: 25,
        viewBox: "0 0 25 25"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd",
        stroke: "#FF3D57",
        strokeLinecap: "square",
        strokeWidth: 4.5
    }, /*#__PURE__*/ react.createElement("path", {
        d: "m4 4 17 17M21 4 4 21"
    }))));
};
/* harmony default export */ var x = (SvgX);

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/comparison-feature/comparison-feature-component.js









var ComparisonFeatureComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ComparisonFeatureComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ComparisonFeatureComponent);
    function ComparisonFeatureComponent() {
        (0,_class_call_check/* default */.Z)(this, ComparisonFeatureComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ComparisonFeatureComponent, [
        {
            key: "renderFeatureValueContnet",
            value: function renderFeatureValueContnet(value) {
                if (value === "true") return /*#__PURE__*/ (0,jsx_runtime.jsx)(v/* default */.Z, {
                    fill: "#00D647"
                });
                if (value === "false") return /*#__PURE__*/ (0,jsx_runtime.jsx)(x, {});
                return value;
            }
        },
        {
            key: "renderFeatureValue",
            value: function renderFeatureValue(value) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "feature-value",
                    children: this.renderFeatureValueContnet(value)
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, monday = _props.monday, competitor = _props.competitor, index = _props.index, bigTexts = _props.bigTexts;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledComparisonFeatureComponent, {
                    className: "table-row-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-row table-feature ".concat(index % 2 == 0 ? "even" : "odd", " ").concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell first-cell",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(monday)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell",
                                    children: this.renderFeatureValue(competitor)
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "table-cell"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-row ".concat(bigTexts ? "big-texts" : ""),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "feature-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "feature-cells",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(monday)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: this.renderFeatureValue(competitor)
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return ComparisonFeatureComponent;
}(react.PureComponent);

ComparisonFeatureComponent.defaultProps = {
    title: null,
    monday: null,
    competitor: null
};

;// CONCATENATED MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var CompetitorsComparisonTableComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(CompetitorsComparisonTableComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(CompetitorsComparisonTableComponent);
    function CompetitorsComparisonTableComponent() {
        (0,_class_call_check/* default */.Z)(this, CompetitorsComparisonTableComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(CompetitorsComparisonTableComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, title = _props.title, subtitle = _props.subtitle, features = _props.features, mondayLogo = _props.mondayLogo, competitorLogo = _props.competitorLogo;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledCompetitorsComparisonTableComponent, {
                    className: "competitors-comparison-table",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "competitors-comparison-titles-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "competitors-comparison-subtitle",
                                    children: subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-row table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell vs-cell",
                                            children: "vs."
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell"
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mobile-table-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "table-header",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "monday-logo-wrapper",
                                                style: {
                                                    height: "".concat(mondayLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "monday-logo",
                                                    src: "/static/img/monday-logos/monday_logo_short.png"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "table-cell",
                                            children: competitorLogo && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "competitor-logo-wrapper",
                                                style: {
                                                    height: "".concat(competitorLogo.height, "%")
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                    className: "competitor-logo",
                                                    src: competitorLogo.src
                                                })
                                            })
                                        })
                                    ]
                                }),
                                features.map(function(feature, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonFeatureComponent, _object_spread_props(_object_spread({}, feature.props), {
                                        index: i
                                    }), i);
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return CompetitorsComparisonTableComponent;
}(react.PureComponent);

CompetitorsComparisonTableComponent.defaultProps = {
    features: [],
    mondayLogo: {}
};


/***/ }),

/***/ 60500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ArticleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/templates/base-template.js + 45 modules
var base_template = __webpack_require__(45338);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/asset-strip/asset-strip-component.scss.js



var StyledAssetStripComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ebjwg9m0"
})("position:relative;width:100vw;max-width:100%;overflow:hidden;img{min-width:100%;}.asset-strip-content{position:absolute;top:0;bottom:0;right:0;left:0;display:flex;flex-direction:column;justify-content:center;align-items:center;text-align:center;.strip-signup-wrapper{margin-top:32px;}.strip-title{color:", colors/* default.white */.Z.white, ";font-size:2.7rem;font-weight:700;margin-bottom:24px;padding:0 48px;}.strip-subtitle{color:", colors/* default.white */.Z.white, ";font-size:1.375rem;margin-bottom:24px;padding:0 48px;}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){.asset-strip-content{.strip-title{font-size:2.25rem;margin-bottom:24px;padding:0 24px;}.strip-subtitle{font-size:1.375rem;margin-bottom:24px;padding:0 24px;}}}@media (max-width:", vp_sizes/* SMALL_MOBILE_QUERY_MAX_WIDTH */.cb, "){.asset-strip-content{.strip-title{font-size:1.75rem;}.strip-subtitle{font-size:1.125rem;}}}");

;// CONCATENATED MODULE: ./components/core/asset-strip/asset-strip-component.js









var AssetStripComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetStripComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetStripComponent);
    function AssetStripComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetStripComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetStripComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, asset = _props.asset, title = _props.title, subtitle = _props.subtitle, height = _props.height, preventSignup = _props.preventSignup, signupFocusOnLoad = _props.signupFocusOnLoad;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAssetStripComponent, {
                    className: "asset-strip-component",
                    style: {
                        height: height
                    },
                    children: [
                        asset && /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                            src: asset.src,
                            alt: asset.alt
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "asset-strip-content",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "strip-title",
                                    children: title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "strip-subtitle",
                                    children: subtitle
                                }),
                                !preventSignup && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "strip-signup-wrapper",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {
                                        focusOnLoad: signupFocusOnLoad
                                    })
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return AssetStripComponent;
}(react.PureComponent);

AssetStripComponent.defaultProps = {
    height: "520px"
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./components/core/signups/signup-with-text/signup-with-text-component.js + 1 modules
var signup_with_text_component = __webpack_require__(77385);
;// CONCATENATED MODULE: ./components/templates/article-template/article-item/article-item-component.scss.js



var StyledArticleItemComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "elwuxy30"
})("&.paragraph{padding:0 32px;}&.signup{margin:80px 0;display:flex;justify-content:center;}&.image,&.highlight{margin:64px 0;padding:0 32px;}.paragraph-title{margin-bottom:8px;font-size:1.75rem;font-weight:400;line-height:42px;}.paragraph-content{margin:0 0 24px 0;font-size:1rem;font-weight:300;line-height:28px;}.article-image{img{width:100%;}}.highlight-item{font-size:1.463rem;font-weight:300;line-height:38px;color:", colors/* default.brand-purple */.Z["brand-purple"], ";}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){&.paragraph,&.image,&.highlight{padding:0;}}");

// EXTERNAL MODULE: ./components/segments/competitors-comparison-table/competitors-comparison-table-component.js + 4 modules
var competitors_comparison_table_component = __webpack_require__(93030);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./components/templates/article-template/article-item/article-item-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}







var ArticleItemComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleItemComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleItemComponent);
    function ArticleItemComponent(props) {
        (0,_class_call_check/* default */.Z)(this, ArticleItemComponent);
        var _this;
        _this = _super.call(this, props);
        _this.renderSignup = _this.renderSignup.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderParagraph = _this.renderParagraph.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderImage = _this.renderImage.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderHighlight = _this.renderHighlight.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderComparisonTable = _this.renderComparisonTable.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(ArticleItemComponent, [
        {
            key: "renderSignup",
            value: function renderSignup() {
                var title = this.props.title;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, {
                    title: title
                });
            }
        },
        {
            key: "renderImage",
            value: function renderImage() {
                var _props = this.props, src = _props.src, alt = _props.alt;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "article-image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                        src: src,
                        alt: alt
                    })
                });
            }
        },
        {
            key: "renderParagraph",
            value: function renderParagraph() {
                var _props = this.props, title = _props.title, isHighlight = _props.isHighlight, content = _props.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "paragraph-title",
                            dangerouslySetInnerHTML: {
                                __html: title
                            }
                        }),
                        content && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "paragraph-content",
                            dangerouslySetInnerHTML: {
                                __html: content
                            }
                        })
                    ]
                });
            }
        },
        {
            key: "renderComparisonTable",
            value: function renderComparisonTable() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(competitors_comparison_table_component/* default */.Z, _object_spread({}, this.props));
            }
        },
        {
            key: "renderHighlight",
            value: function renderHighlight() {
                var content = this.props.content;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "highlight-item",
                    children: content
                });
            }
        },
        {
            key: "mapPartTypeToRenderer",
            value: function mapPartTypeToRenderer() {
                var partType = this.props.partType;
                switch(partType){
                    case "paragraph":
                        {
                            return this.renderParagraph;
                        }
                    case "signup":
                        {
                            return this.renderSignup;
                        }
                    case "image":
                        {
                            return this.renderImage;
                        }
                    case "highlight":
                        {
                            return this.renderHighlight;
                        }
                    case "comparisonTable":
                        {
                            return this.renderComparisonTable;
                        }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, partType = _props.partType, content = _props.content, title = _props.title;
                var partRenderer = this.mapPartTypeToRenderer();
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArticleItemComponent, {
                    className: "article-item-component ".concat(partType),
                    children: partRenderer()
                });
            }
        }
    ]);
    return ArticleItemComponent;
}(react.PureComponent);
/* harmony default export */ var article_item_component = ((0,generic_config_context/* withGenericConfig */.P)(ArticleItemComponent));

// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/templates/article-template/article-template-content/article-template-content-component.scss.js


var StyledArticleTemplateContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e7902d70"
})("display:flex;flex-direction:column;align-items:center;.article-items-list{margin:72px 0 64px 0;width:800px;}.content-footer-signup-wrapper{margin-bottom:24px;padding:0 24px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.article-items-list{width:calc(100vw - 48px);}}.footer-disclaimer{font-size:0.8125rem;text-align:left;width:800px;padding:16px 32px;}");

;// CONCATENATED MODULE: ./components/templates/article-template/article-template-content/article-template-content-component.js




function article_template_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_template_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_template_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var ArticleTemplateContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleTemplateContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleTemplateContentComponent);
    function ArticleTemplateContentComponent() {
        (0,_class_call_check/* default */.Z)(this, ArticleTemplateContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ArticleTemplateContentComponent, [
        {
            key: "shouldRenderFooterSignupForm",
            value: function shouldRenderFooterSignupForm() {
                var footerSignup = this.props.footerSignup;
                return footerSignup && !footerSignup.preventSignup;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerStrip = _props.headerStrip, parts = _props.parts, footerSignup = _props.footerSignup, footerDisclaimer = _props.footerDisclaimer, abTests = _props.abTests;
                var shouldFocusOnSignup = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledArticleTemplateContentComponent, {
                    className: "article-template-content-component",
                    children: [
                        headerStrip && /*#__PURE__*/ (0,jsx_runtime.jsx)(AssetStripComponent, {
                            asset: headerStrip.asset,
                            title: headerStrip.title,
                            subtitle: headerStrip.subtitle,
                            preventSignup: headerStrip.preventSignup,
                            signupFocusOnLoad: shouldFocusOnSignup
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "article-items-list",
                            children: parts.map(function(part, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(article_item_component, article_template_content_component_object_spread({
                                    partType: part.type
                                }, part.props), index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "content-footer-signup-wrapper",
                            children: this.shouldRenderFooterSignupForm() && /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_with_text_component/* default */.Z, {
                                title: footerSignup.title,
                                subtitle: footerSignup.subtitle
                            })
                        }),
                        footerDisclaimer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer-disclaimer",
                            dangerouslySetInnerHTML: {
                                __html: footerDisclaimer
                            }
                        })
                    ]
                });
            }
        }
    ]);
    return ArticleTemplateContentComponent;
}(react.PureComponent);
/* harmony default export */ var article_template_content_component = ((0,ab_tests_context/* withAbTests */.k)(ArticleTemplateContentComponent));

// EXTERNAL MODULE: ./segments/desktop/header/layouts/base-header/base-header-component.js + 116 modules
var base_header_component = __webpack_require__(77097);
// EXTERNAL MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js + 1 modules
var long_footer_component = __webpack_require__(55408);
;// CONCATENATED MODULE: ./components/templates/article-template/article-template.js




function article_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function article_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            article_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






 //new for monday 2.0
 // //new for monday 2.0
var ArticleTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ArticleTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ArticleTemplate);
    function ArticleTemplate() {
        (0,_class_call_check/* default */.Z)(this, ArticleTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ArticleTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var topbar = pageConfig.topbar, headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, _footer = pageConfig.footer, footer = _footer === void 0 ? {} : _footer, exitPopupConfig = pageConfig.exitPopupConfig;
                var preventMenu = topbar && topbar.preventMenu;
                var preventFooter = footer && footer.preventFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, _object_spread_props(article_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(base_header_component["default"], {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: !preventMenu,
                            headerBackgroundColor: "white",
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            socialButtonBlogStyle: socialButtons && socialButtons.blogStyle,
                            topBanner: topBanner
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            id: element_ids/* MAIN_ID */.k,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(article_template_content_component, {
                                headerStrip: headerStrip,
                                parts: parts,
                                footerSignup: footerSignup,
                                footerDisclaimer: footer.disclaimer
                            })
                        }),
                        !preventFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_component["default"], {
                            nameSignature: nameSignature,
                            showTrustpilotReviews: pageConfig.showTrustpilotReviews
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return ArticleTemplate;
}(react.PureComponent);

ArticleTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 61167:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G8": function() { return /* binding */ HEADER_POPUP_OPTIONS; },
/* harmony export */   "Yq": function() { return /* binding */ HEADER_POPUP_DATA; }
/* harmony export */ });
/* unused harmony exports RING_THE_BELL_VALUE, IPO_BLOG_POST_VALUE, ELEVATE_REGISTRATION_VALUE, RING_THE_BELL_TEXT, IPO_BLOG_POST_TEXT, ELEVATE_REGISTRATION_TEXT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var constants_links__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27639);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72632);
/* harmony import */ var constants_localization__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(constants_localization__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);




var RING_THE_BELL_VALUE = "ring_the_bell";
var IPO_BLOG_POST_VALUE = "ipo_blog_post";
var ELEVATE_REGISTRATION_VALUE = "elevate_registration";
var RING_THE_BELL_TEXT = "Ring the bell";
var IPO_BLOG_POST_TEXT = "IPO blog post";
var ELEVATE_REGISTRATION_TEXT = "Elevate Registration";
var HEADER_POPUP_OPTIONS = [
    {
        value: RING_THE_BELL_VALUE,
        text: RING_THE_BELL_TEXT
    },
    {
        value: IPO_BLOG_POST_VALUE,
        text: IPO_BLOG_POST_TEXT
    },
    {
        value: ELEVATE_REGISTRATION_VALUE,
        text: ELEVATE_REGISTRATION_TEXT
    }
];
var CLOUDINARY_BELL_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/ipo/ipo-bell-gif.gif";
var ELEVATE_GIF_SRC = "https://dapulse-res.cloudinary.com/image/upload/q_auto/mondayhomepage/elevate/star-rect.gif";
var ELEVATE_MOBILE_IMAGE_SRC = "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/mondayhomepage/elevate/star-static.png";
var getRingTheBellLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .RING_THE_BELL_VIDEO_LINK */ .Kk$;
};
var getIpoBlogPostLink = function(locale) {
    switch(locale){
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.SPANISH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_SPANISH_LINK */ .zjT;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.PORTUGEESE_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_PORTUGESE_LINK */ .aL4;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.GERMAN_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_GERMAN_LINK */ .mF0;
        case constants_localization__WEBPACK_IMPORTED_MODULE_1__.FRENCH_LOCALE_ID:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_FRENCH_LINK */ .div;
        default:
            return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .IPO_BLOG_POST_LINK */ .vWk;
    }
};
var getElevateRegitrationLink = function() {
    return constants_links__WEBPACK_IMPORTED_MODULE_0__/* .ELEVATE_MAIN_PAGE_LINK */ .Csm;
};
var _obj;
var HEADER_POPUP_DATA = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, RING_THE_BELL_VALUE, {
    textKey: "header.ipo.popup.ringTheBell.mainText",
    ctaKey: "header.ipo.popup.ringTheBell.cta",
    getLink: getRingTheBellLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, IPO_BLOG_POST_VALUE, {
    textKey: "header.ipo.popup.ipoBlogPost.mainText",
    ctaKey: "header.ipo.popup.ipoBlogPost.cta",
    getLink: getIpoBlogPostLink,
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .PURPLE_THEME_ID */ .qF,
    gifSrc: CLOUDINARY_BELL_GIF_SRC
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, ELEVATE_REGISTRATION_VALUE, {
    textKey: "header.elevate.popup.mainText",
    mobileTextKey: "header.elevate.popup.mobileText",
    ctaKey: "header.elevate.popup.cta",
    getLink: getElevateRegitrationLink,
    popupClassName: "elevate",
    bannerTheme: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .GRADIANT_ELEVATE_THEME_ID */ .wk,
    gifSrc: ELEVATE_GIF_SRC,
    mobileImageSrc: ELEVATE_MOBILE_IMAGE_SRC
}), _obj);


/***/ }),

/***/ 65415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ArticleTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_article_template_article_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60500);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var ArticleTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ArticleTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(ArticleTemplatePage);
    function ArticleTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, ArticleTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(ArticleTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_article_template_article_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return ArticleTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_3__);








var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 14285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ long_footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./client/services/cluster-config-service/cluster-config-service.js
var cluster_config_service = __webpack_require__(79092);
// EXTERNAL MODULE: ./components/core/short-footer/short-footer.js + 4 modules
var short_footer = __webpack_require__(69861);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/default-props.js
/* harmony default export */ var default_props = ({});

// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-category/footer-category-component.js + 1 modules
var footer_category_component = __webpack_require__(70212);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.scss.js
var long_footer_scss = __webpack_require__(17619);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/footer-bottom-bar/footer-bottom-bar-component.js + 10 modules
var footer_bottom_bar_component = __webpack_require__(46374);
// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
;// CONCATENATED MODULE: ./segments/desktop/core-components/long-footer/long-footer.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}











var Footer = function(props) {
    var translate = props.translate, localeId = props.localeId, abTests = props.abTests, pageClusterConfig = props.pageClusterConfig, useProductMiniSiteConfig = props.useProductMiniSiteConfig;
    var LONG_FOOTER = "long";
    var renderShortFooter = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer/* default */.Z, _object_spread({}, props));
    };
    var renderLongFooter = function() {
        var getFullFooterForLocalized = true;
        var footerComponents = (0,localization_service/* getFooterComponents */.L8)(localeId, abTests, getFullFooterForLocalized, {});
        if (pageClusterConfig) {
            (0,cluster_config_service/* updateClusterFooterLinks */.R4)(pageClusterConfig, footerComponents, {
                useProductMiniSiteConfig: useProductMiniSiteConfig
            });
        }
        var MondayFooterLinks = footerComponents.MondayFooterLinks, OurTeamFooterLinksV2 = footerComponents.OurTeamFooterLinksV2, MoreByMondayFooterLinks = footerComponents.MoreByMondayFooterLinks, UseCasesFooterLinksV2 = footerComponents.UseCasesFooterLinksV2, ResourcesFooterLinks = footerComponents.ResourcesFooterLinks, ProductsFooterLinks = footerComponents.ProductsFooterLinks, FeaturesFooterLinks = footerComponents.FeaturesFooterLinks;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(long_footer_scss/* StyledFooter */.tc, {
            className: "footer-container",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "footer-content-container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                        className: "footer-content",
                        "aria-label": "Footer",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "categories-container",
                            children: [
                                MondayFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(MondayFooterLinks.title),
                                        links: MondayFooterLinks.links,
                                        hasMondayLogoTitle: MondayFooterLinks.hasMondayLogoTitle
                                    })
                                }),
                                FeaturesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container features",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(FeaturesFooterLinks.title),
                                        links: FeaturesFooterLinks.links
                                    })
                                }),
                                ProductsFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container products",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "categories-colmmn-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: ProductsFooterLinks.type,
                                                title: translate(ProductsFooterLinks.title),
                                                links: ProductsFooterLinks.links
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                                type: MoreByMondayFooterLinks.type,
                                                title: translate(MoreByMondayFooterLinks.title),
                                                links: MoreByMondayFooterLinks.links
                                            })
                                        ]
                                    })
                                }),
                                UseCasesFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        title: translate(UseCasesFooterLinksV2.title),
                                        links: UseCasesFooterLinksV2.links
                                    })
                                }),
                                OurTeamFooterLinksV2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: OurTeamFooterLinksV2.type,
                                        title: translate(OurTeamFooterLinksV2.title),
                                        links: OurTeamFooterLinksV2.links
                                    })
                                }),
                                ResourcesFooterLinks && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "category-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_category_component/* default */.Z, {
                                        type: ResourcesFooterLinks.type,
                                        title: translate(ResourcesFooterLinks.title),
                                        links: ResourcesFooterLinks.links
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_bottom_bar_component/* default */.Z, {
                    SocialFooterLinks: links/* SocialFooterLinks */.Ff7,
                    footerType: LONG_FOOTER
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledDesktopFooterContainer */.w2, {
                className: "footer-desktop-wrapper",
                children: renderLongFooter()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer_scss/* StyledMobileFooterContainer */.qJ, {
                className: "footer-mobile-wrapper",
                children: renderShortFooter()
            })
        ]
    });
};
/* harmony default export */ var long_footer = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)(Footer)));
Footer.defaultProps = default_props;


/***/ }),

/***/ 55408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ LongFooterComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/long-footer/long-footer.js + 1 modules
var long_footer = __webpack_require__(14285);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.scss.js

var StyledLongFooterComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1rc6ysx0"
})();

;// CONCATENATED MODULE: ./segments/desktop/footer/layouts/long-footer/long-footer-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}





var LongFooterComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(LongFooterComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(LongFooterComponent);
    function LongFooterComponent() {
        (0,_class_call_check/* default */.Z)(this, LongFooterComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(LongFooterComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLongFooterComponent, {
                    className: "long-footer-component",
                    id: element_ids/* FOOTER_ID */.D,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(long_footer/* default */.Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return LongFooterComponent;
}(react.PureComponent);

LongFooterComponent.defaultProps = {};


/***/ }),

/***/ 24730:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var Sentry = __webpack_require__(48491);
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var logException = (__webpack_require__(98989).logException);
var handleServerException = function() {
    var _ref = _async_to_generator(function(param) {
        var externalMessage, e, req, res, extraLogParams, _bbEventParams, bbEventParams;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    externalMessage = param.externalMessage, e = param.e, req = param.req, res = param.res, extraLogParams = param.extraLogParams, _bbEventParams = param.bbEventParams, bbEventParams = _bbEventParams === void 0 ? {} : _bbEventParams;
                    // 1. log to Coralogix
                    logException({
                        externalMessage: externalMessage,
                        e: e,
                        req: req,
                        res: res,
                        extraLogParams: extraLogParams
                    });
                    // 2. capture exception in Sentry
                    Sentry.captureException(e);
                    return [
                        4,
                        Sentry.flush(2000)
                    ];
                case 1:
                    _state.sent();
                    // 3. track server exception on BigBrain
                    return [
                        4,
                        trackBigBrainEventOnServer(bbEventParams.name || "server_exception", {
                            kind: bbEventParams.kind,
                            placement: req && req.url,
                            info1: e && e.message,
                            info2: req && req.params && req.params.id,
                            directObject: req && req.hostname
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function handleServerException(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    handleServerException: handleServerException
};


/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ }),

/***/ 62587:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (Array.isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};


/***/ }),

/***/ 12361:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return Object.keys(obj).map(function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (Array.isArray(obj[k])) {
        return obj[k].map(function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};


/***/ }),

/***/ 17673:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(62587);
exports.encode = exports.stringify = __webpack_require__(12361);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7229,6602,390,8559,5365,8486,1489,9359,5657,932,4494,4961,1068,3211,9160,1360,4916,6022,3203,5338,787,7097,9774,2888,179], function() { return __webpack_exec__(32411); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);